function ready() {
  // do your stuff
  var seeMoreElements = document.getElementsByClassName("see-more");
  if(seeMoreElements.length == 1){
    var seeLessElements = document.getElementsByClassName("see-less");
    if(seeLessElements.length == 1){      
      console.log(seeMoreElements); 
      console.log(seeLessElements);
      var seeMoreElem = seeMoreElements[0];
      var seeLessElem = seeLessElements[0];
      var description = document.getElementsByClassName("collection-banner-description")[0];

      // see more event
      seeMoreElem.addEventListener('click', () => {
        seeMoreElem.style.display='none';
        seeLessElem.style.display='block';   
        // show all
        description.style["-webkit-line-clamp"]='10000';
      });

      // see less event
      seeLessElem.addEventListener('click', () => {
        seeLessElem.style.display='none';
        seeMoreElem.style.display='block';        
        // show all
        description.style["-webkit-line-clamp"]='3';
      });
      
    }
  }
}

if (document.readyState !== 'loading') {
  ready();
} else {
  document.addEventListener('DOMContentLoaded', ready);
}
